export default [
	{
		title: "Google My Business Playbook",
		items: [
			{
				title: "🔃 Review Google My Business Playbook",
				info: "pb:googleMyBusinessPlaybook",
				id: "googlebiz:TyqbmBsO"
			},
			{
				title: "⚠️ Optimize Google Profile with bio/updated photos/landing page",
				id: "googlebiz:XbQmnILo"
			},
			{
				title: "⭐ Collect 5-star reviews",
				id: "googlebiz:WDigcBO4"
			},
			{
				title: "👨‍🔧 Implement Local Service Ads",
				info: "pb:googleMyBusinessPlaybook",
				id: "googlebiz:googleMyBusinessPlaybook"
			},
			{
				title: "🗨️ Reply to Facebook messenger requests with standard copy/paste",
				videoUrl: "https://www.loom.com/share/e1fe153cce6a402895db10b04cf1e237?sid=617fc73f-20d7-4e18-a6b6-04fa870de925",
				id: "googlebiz:VqxtALvM"
			},
			{
				title: "📞Call back new leads using the bribe call script",
				info: "https://docs.google.com/document/d/1NusY3xpq6riQcp_O4qo07oDw6lQ43HDm086UcRVTZm4/edit?usp=sharing",
				id: "googlebiz:t_7asikK"
			},
			{
				title: "📞Retry calling earlier leads (5 strikes rule)",
				id: "googlebiz:gO-nFUVG"
			},
			{
				title: "📞Call back new bribe calls with next step script",
				info: "https://docs.google.com/document/d/1w4NHSyVq7kRgvB9rGYnCZ0V8U5pgJOr6hsfXsHTW9yQ/edit?usp=sharing",
				id: "googlebiz:0xx1CLcT"
			}
		],
		id: "FQsMqVQP"
	},
	{
		title: "Become A Followup Master",
		items: [
			{
				title: "🔃 Review the bribe call playbook",
				info: "pb:bribeCallPlaybook",
				id: "googlebiz:SFWE1Avl"
			},
			{
				title: "📞 Call back day 1 leads with bribe call script (no email, no text, no voicemail!!!)",
				info: "https://docs.google.com/document/d/1NusY3xpq6riQcp_O4qo07oDw6lQ43HDm086UcRVTZm4/edit?usp=sharing",
				id: "googlebiz:iHzQJsHA"
			},
			{
				title: "📧 Email or text your coach with first bribe call (Big win #2!)",
				id: "googlebiz:gpPAZMNc"
			},
			{
				title: "⬆️ Import 3 more listings",
				videoUrl: "https://www.loom.com/share/d34a3595e9044294b556e655d1111be9?sid=584202c0-b980-44d4-abbd-adc4dead5f5e",
				id: "googlebiz:s8rTUgqY"
			},
			{
				title: "✨☮️ Create and post 3 more Craigslist ads",
				info: "pb:craigslistPlaybook",
				id: "googlebiz:craigslistPlaybook"
			},
			{
				title: "✨📣 Create and post 3 ads with PPT for Facebook Marketplace",
				info: "pb:fbmarketplacePlaybook",
				id: "googlebiz:fbmarketplacePlaybook"
			},
			{
				title: "Submit CL ads for review",
				id: "googlebiz:B8qpp9LJ"
			},
			{
				title: "🗨️ Reply to Facebook messenger requests with standard copy/paste",
				videoUrl: "https://www.loom.com/share/e1fe153cce6a402895db10b04cf1e237?sid=617fc73f-20d7-4e18-a6b6-04fa870de925",
				id: "googlebiz:VqxtALvM"
			},
			{
				title: "💬☮️ Text your coach with ad results from Craigslist ads",
				videoUrl: "https://www.loom.com/share/81ba0ae41f8b472f96203893ebdeda30?sid=55ab2554-ab30-4344-96a4-68d76ac459aa",
				id: "googlebiz:o5mLbuIW"
			}
		],
		id: "Qt547t1e"
	},
	{
		title: "Zillow-jacking Playbook",
		items: [
			{
				title: "🔃 Review Zillow-Jacking playbook",
				info: "pb:zillowJackingPlaybook",
				id: "googlebiz:677698e82a25f956ac567a33"
			},
			{
				title: "🔎 Search and download FSBOs in your area",
				videoUrl: "https://www.loom.com/share/81f9ba79de36473cbc7c2b3f3db063c3?sid=7e9bd0a6-f43f-4938-bb2d-6d406a2bca15",
				id: "googlebiz:DdF1t-kG"
			},
			{
				title: "📞Call 5 FSBOs with the Fizbonanza script",
				info: "https://docs.google.com/document/d/12hwfJFR2PYATGoOkPR-cVRo6gWWmu_WQznl_4ysR1RU/edit?usp=sharing",
				id: "googlebiz:3H5Khp1A"
			},
			{
				title: "♻️☮️ Renew Craigslist ads",
				videoUrl: "https://www.loom.com/share/ab32d161a47142e58ab19f52aa1e6e36?sid=956c9d53-5b52-4029-8b3d-f3fa8f89b5f9",
				id: "googlebiz:6sf5aseX"
			},
			{
				title: "🗨️ Reply to Facebook messenger requests with standard copy/paste",
				videoUrl: "https://www.loom.com/share/e1fe153cce6a402895db10b04cf1e237?sid=617fc73f-20d7-4e18-a6b6-04fa870de925",
				id: "googlebiz:VqxtALvM"
			},
			{
				title: "📞Call back new leads using the bribe call script",
				info: "https://docs.google.com/document/d/1NusY3xpq6riQcp_O4qo07oDw6lQ43HDm086UcRVTZm4/edit?usp=sharing",
				id: "googlebiz:t_7asikK"
			},
			{
				title: "📞Retry calling earlier leads (5 strikes rule)",
				id: "googlebiz:gO-nFUVG"
			},
			{
				title: "📞Call back new bribe calls with next step script",
				info: "https://docs.google.com/document/d/1w4NHSyVq7kRgvB9rGYnCZ0V8U5pgJOr6hsfXsHTW9yQ/edit?usp=sharing",
				id: "googlebiz:0xx1CLcT"
			}
		],
		id: "AmdJiRpZ"
	},
	{
		title: "Connect A Crm",
		items: [
			{
				title: "🔁 Sync leads with CRM (heyhatcher.com)",
				videoUrl: "https://www.loom.com/share/95bd7c68327c4492a6e478d0b264d1ba?sid=d949b6e7-7ac6-43c3-a0b2-1af483991e4f",
				id: "googlebiz:XVAA3r0t"
			},
			{
				title: "📲 Setup Auto-Dialer in Hatcher",
				videoUrl: "https://www.loom.com/share/03b3479f5d734065946eb95bb49cd5fb?sid=5f824170-5d9c-45af-8fe9-fab2dcdfb870",
				id: "googlebiz:bSjNiNrc"
			},
			{
				title: "📷 Photo/Video appt. #1 from Zillow-Jacking playbook",
				videoUrl: "https://www.loom.com/share/5567b85621344542a14bd66e61f581cc?sid=b55d2bd5-c259-4c14-b204-def0c6125e32",
				id: "googlebiz:PkKqNMsV"
			},
			{
				title: "📞Call #2 after FSBO appt with the Fizbonanza script",
				info: "https://docs.google.com/document/d/12hwfJFR2PYATGoOkPR-cVRo6gWWmu_WQznl_4ysR1RU/edit?usp=sharing",
				id: "googlebiz:zillowJackingPlaybook"
			},
			{
				title: "♻️☮️ Renew Craigslist ads",
				videoUrl: "https://www.loom.com/share/ab32d161a47142e58ab19f52aa1e6e36?sid=956c9d53-5b52-4029-8b3d-f3fa8f89b5f9",
				id: "googlebiz:6sf5aseX"
			},
			{
				title: "🗨️ Reply to Facebook messenger requests with standard copy/paste",
				videoUrl: "https://www.loom.com/share/e1fe153cce6a402895db10b04cf1e237?sid=617fc73f-20d7-4e18-a6b6-04fa870de925",
				id: "googlebiz:VqxtALvM"
			},
			{
				title: "📞Call back new leads using the bribe call script",
				info: "https://docs.google.com/document/d/1NusY3xpq6riQcp_O4qo07oDw6lQ43HDm086UcRVTZm4/edit?usp=sharing",
				id: "googlebiz:t_7asikK"
			},
			{
				title: "📞Retry calling earlier leads (5 strikes rule)",
				id: "googlebiz:gO-nFUVG"
			},
			{
				title: "📞Call back new bribe calls with next step script",
				info: "https://docs.google.com/document/d/1w4NHSyVq7kRgvB9rGYnCZ0V8U5pgJOr6hsfXsHTW9yQ/edit?usp=sharing",
				id: "googlebiz:0xx1CLcT"
			}
		],
		id: "K0Rp-agA"
	},
	{
		title: "Progress Review",
		items: [
			{
				title: "📅 Schedule a Progress Review with your coach",
				info: "https://calendly.com/customer-success-55/progress-review",
				id: "googlebiz:Rk4tFOBr"
			},
			{
				title: "📷 Photo/Video appt. #2 from Zillow-Jacking playbook",
				videoUrl: "https://www.loom.com/share/5567b85621344542a14bd66e61f581cc?sid=b55d2bd5-c259-4c14-b204-def0c6125e32",
				id: "googlebiz:gJJ0uCCB"
			},
			{
				title: "📞Call #2 after FSBO appt with the Fizbonanza script",
				info: "https://docs.google.com/document/d/12hwfJFR2PYATGoOkPR-cVRo6gWWmu_WQznl_4ysR1RU/edit?usp=sharing",
				id: "googlebiz:GCBYjxT9"
			},
			{
				title: "♻️☮️ Renew Craigslist ads",
				videoUrl: "https://www.loom.com/share/ab32d161a47142e58ab19f52aa1e6e36?sid=956c9d53-5b52-4029-8b3d-f3fa8f89b5f9",
				id: "googlebiz:6sf5aseX"
			},
			{
				title: "🗨️ Reply to Facebook messenger requests with standard copy/paste",
				videoUrl: "https://www.loom.com/share/e1fe153cce6a402895db10b04cf1e237?sid=617fc73f-20d7-4e18-a6b6-04fa870de925",
				id: "googlebiz:VqxtALvM"
			},
			{
				title: "📞Call back new leads using the bribe call script",
				info: "https://docs.google.com/document/d/1NusY3xpq6riQcp_O4qo07oDw6lQ43HDm086UcRVTZm4/edit?usp=sharing",
				id: "googlebiz:t_7asikK"
			},
			{
				title: "📞Retry calling earlier leads (5 strikes rule)",
				id: "googlebiz:gO-nFUVG"
			},
			{
				title: "📞Call back new bribe calls with next step script",
				info: "https://docs.google.com/document/d/1w4NHSyVq7kRgvB9rGYnCZ0V8U5pgJOr6hsfXsHTW9yQ/edit?usp=sharing",
				id: "googlebiz:0xx1CLcT"
			},
			{
				title: "📧 Text or email your coach an if you have had any successful pre-qualifications (Big Win #3)",
				id: "googlebiz:uJuKrbGv"
			}
		],
		id: "SwjGczqR"
	},
	{
		title: "Upcirculating Playbook",
		items: [
			{
				title: "🔃 Review the upcirculating playbook",
				info: "pb:upcirculatingPlaybook",
				videoUrl: "https://www.loom.com/share/19b36eff4da547f0b36d64dddf3fcb69?sid=e3d53481-44e1-4b3a-a9a4-6f5d3321f1c8",
				id: "googlebiz:677692002a25f956ac567a2b"
			},
			{
				title: "✨ Create your inner and outer circle list using the upcirculating tool",
				info: "https://docs.google.com/spreadsheets/d/1TCUEVkELm2gShAXtPcaQ8XmXBK2beA8wTUY8iFBsrjA/edit?usp=sharing",
				id: "googlebiz:YLkz7_4F"
			},
			{
				title: "🗣️ Make the ask (from the upcirculating playbook)",
				info: "https://docs.google.com/document/d/12hwfJFR2PYATGoOkPR-cVRo6gWWmu_WQznl_4ysR1RU/edit?usp=sharing",
				id: "googlebiz:9TBhIkQj"
			},
			{
				title: "📣 Post a borrowed listing to your Facebook feed",
				id: "googlebiz:TPUxpg14"
			},
			{
				title: "Submit Upcirculating post for review",
				id: "googlebiz:upcirculatingPlaybook"
			},
			{
				title: "📧 Email/text your coach with how many shares you got",
				id: "googlebiz:GqKk5UaZ"
			},
			{
				title: "♻️☮️ Renew Craigslist ads",
				videoUrl: "https://www.loom.com/share/ab32d161a47142e58ab19f52aa1e6e36?sid=956c9d53-5b52-4029-8b3d-f3fa8f89b5f9",
				id: "googlebiz:6sf5aseX"
			},
			{
				title: "🗨️ Reply to Facebook messenger requests with standard copy/paste",
				videoUrl: "https://www.loom.com/share/e1fe153cce6a402895db10b04cf1e237?sid=617fc73f-20d7-4e18-a6b6-04fa870de925",
				id: "googlebiz:VqxtALvM"
			},
			{
				title: "📞Call back new leads using the bribe call script",
				info: "https://docs.google.com/document/d/1NusY3xpq6riQcp_O4qo07oDw6lQ43HDm086UcRVTZm4/edit?usp=sharing",
				id: "googlebiz:t_7asikK"
			},
			{
				title: "📞Retry calling earlier leads (5 strikes rule)",
				id: "googlebiz:gO-nFUVG"
			},
			{
				title: "📞Call back new bribe calls with next step script",
				info: "https://docs.google.com/document/d/1w4NHSyVq7kRgvB9rGYnCZ0V8U5pgJOr6hsfXsHTW9yQ/edit?usp=sharing",
				id: "googlebiz:0xx1CLcT"
			}
		],
		id: "gPlJBfE7"
	},
	{
		title: "Ad Review",
		items: [
			{
				title: "🔃 Review your ad performance",
				videoUrl: "https://www.loom.com/share/5567b85621344542a14bd66e61f581cc?sid=b55d2bd5-c259-4c14-b204-def0c6125e32",
				id: "googlebiz:_UgiEg97"
			},
			{
				title: "👎 Replace non-performing ads",
				videoUrl: "https://www.loom.com/share/5567b85621344542a14bd66e61f581cc?sid=b55d2bd5-c259-4c14-b204-def0c6125e32",
				id: "googlebiz:B4mTRBv_"
			},
			{
				title: "♻️☮️ Renew Craigslist ads",
				videoUrl: "https://www.loom.com/share/ab32d161a47142e58ab19f52aa1e6e36?sid=956c9d53-5b52-4029-8b3d-f3fa8f89b5f9",
				id: "googlebiz:6sf5aseX"
			},
			{
				title: "🗨️ Reply to Facebook messenger requests with standard copy/paste",
				videoUrl: "https://www.loom.com/share/e1fe153cce6a402895db10b04cf1e237?sid=617fc73f-20d7-4e18-a6b6-04fa870de925",
				id: "googlebiz:VqxtALvM"
			},
			{
				title: "📞Call back new leads using the bribe call script",
				info: "https://docs.google.com/document/d/1NusY3xpq6riQcp_O4qo07oDw6lQ43HDm086UcRVTZm4/edit?usp=sharing",
				id: "googlebiz:t_7asikK"
			},
			{
				title: "📞Retry calling earlier leads (5 strikes rule)",
				id: "googlebiz:gO-nFUVG"
			},
			{
				title: "📞Call back new bribe calls with next step script",
				info: "https://docs.google.com/document/d/1w4NHSyVq7kRgvB9rGYnCZ0V8U5pgJOr6hsfXsHTW9yQ/edit?usp=sharing",
				id: "googlebiz:0xx1CLcT"
			}
		],
		id: "JUBnw0t7"
	},
	{
		title: "X-forecast Playbook",
		items: [
			{
				title: "🔃 Review the X-forecast playbook",
				info: "pb:xforecastPlaybook",
				videoUrl: "https://www.loom.com/share/0cde554ba927489d90fdf0556b14ce1b?sid=e6060360-bb3a-4fa9-89a8-e3beac6911bf",
				id: "googlebiz:EWcbjRax"
			},
			{
				title: "📊 Deep dive into market stats",
				videoUrl: "https://www.loom.com/share/8227922c07ca4842a4618a88da7cb39e",
				id: "googlebiz:1opBpCAP"
			},
			{
				title: "🎥 Go live with market stats!",
				videoUrl: "https://www.loom.com/share/c61f9cd70dfa413fb4e3949ae5eb3e63?sid=e0820db4-dd5b-4856-8417-945561004fa7",
				id: "googlebiz:ATyWoUBP"
			},
			{
				title: "📧 Send link to completed live video to your coach (support@guerillarealty.com)",
				id: "googlebiz:xforecastPlaybook"
			},
			{
				title: "♻️ Renew Facebook ads from day 3",
				videoUrl: "https://www.loom.com/share/91a5faf0b44a482badd6035cb2ca1cc5?sid=fe1ccb52-6891-42b7-97cf-2fb127de93bc",
				id: "googlebiz:nSpE_ZIh"
			},
			{
				title: "♻️☮️ Renew Craigslist ads",
				videoUrl: "https://www.loom.com/share/ab32d161a47142e58ab19f52aa1e6e36?sid=956c9d53-5b52-4029-8b3d-f3fa8f89b5f9",
				id: "googlebiz:6sf5aseX"
			},
			{
				title: "🗨️ Reply to Facebook messenger requests with standard copy/paste",
				videoUrl: "https://www.loom.com/share/e1fe153cce6a402895db10b04cf1e237?sid=617fc73f-20d7-4e18-a6b6-04fa870de925",
				id: "googlebiz:VqxtALvM"
			},
			{
				title: "📞Call back new leads using the bribe call script",
				info: "https://docs.google.com/document/d/1NusY3xpq6riQcp_O4qo07oDw6lQ43HDm086UcRVTZm4/edit?usp=sharing",
				id: "googlebiz:t_7asikK"
			},
			{
				title: "📞Retry calling earlier leads (5 strikes rule)",
				id: "googlebiz:gO-nFUVG"
			},
			{
				title: "📞Call back new bribe calls with next step script",
				info: "https://docs.google.com/document/d/1w4NHSyVq7kRgvB9rGYnCZ0V8U5pgJOr6hsfXsHTW9yQ/edit?usp=sharing",
				id: "googlebiz:0xx1CLcT"
			}
		],
		id: "Psn9-KL9"
	},
	{
		title: "Bulletproof Cma Playbook",
		items: [
			{
				title: "🔃 Review the Bulletproof CMA playbook",
				info: "pb:bcmaPlaybook",
				videoUrl: "https://www.loom.com/share/2d9f3c8c633049229e80ebe446ba08fe?sid=a0edc91d-58a9-4688-afef-df6632dcc9b5",
				id: "googlebiz:Lp0OrrEg"
			},
			{
				title: "💲 Prepare CMAs for seller leads",
				videoUrl: "https://www.loom.com/share/23c5692042144031803cb4b689b44755?sid=029a39aa-745c-4103-87a0-a37badc5df30",
				id: "googlebiz:bcmaPlaybook"
			},
			{
				title: "♻️☮️ Renew Craigslist ads",
				videoUrl: "https://www.loom.com/share/ab32d161a47142e58ab19f52aa1e6e36?sid=956c9d53-5b52-4029-8b3d-f3fa8f89b5f9",
				id: "googlebiz:6sf5aseX"
			},
			{
				title: "🗨️ Reply to Facebook messenger requests with standard copy/paste",
				videoUrl: "https://www.loom.com/share/e1fe153cce6a402895db10b04cf1e237?sid=617fc73f-20d7-4e18-a6b6-04fa870de925",
				id: "googlebiz:VqxtALvM"
			},
			{
				title: "📞Call back new leads using the bribe call script",
				info: "https://docs.google.com/document/d/1NusY3xpq6riQcp_O4qo07oDw6lQ43HDm086UcRVTZm4/edit?usp=sharing",
				id: "googlebiz:t_7asikK"
			},
			{
				title: "📞Retry calling earlier leads (5 strikes rule)",
				id: "googlebiz:gO-nFUVG"
			},
			{
				title: "📞Call back new bribe calls with next step script",
				info: "https://docs.google.com/document/d/1w4NHSyVq7kRgvB9rGYnCZ0V8U5pgJOr6hsfXsHTW9yQ/edit?usp=sharing",
				id: "googlebiz:0xx1CLcT"
			}
		],
		id: "eH33y86R"
	},
	{
		title: "The Ultimate Listing Presentation",
		items: [
			{
				title: "🔃 Review the Ultimate Listing Presentation playbook",
				id: "googlebiz:VUhgK0ax"
			},
			{
				title: "📈 Become a Market Expert",
				id: "googlebiz:9LiKOH9W"
			},
			{
				title: "📞 Present ULP via phone",
				id: "googlebiz:theULPPlaybook"
			},
			{
				title: "🔎 Search and download FSBOs in your area",
				videoUrl: "https://www.loom.com/share/81f9ba79de36473cbc7c2b3f3db063c3?sid=7e9bd0a6-f43f-4938-bb2d-6d406a2bca15",
				id: "googlebiz:DdF1t-kG"
			},
			{
				title: "📞Call 5 FSBOs with the Fizbonanza script",
				info: "https://docs.google.com/document/d/12hwfJFR2PYATGoOkPR-cVRo6gWWmu_WQznl_4ysR1RU/edit?usp=sharing",
				id: "googlebiz:3H5Khp1A"
			},
			{
				title: "♻️☮️ Renew Craigslist ads",
				videoUrl: "https://www.loom.com/share/ab32d161a47142e58ab19f52aa1e6e36?sid=956c9d53-5b52-4029-8b3d-f3fa8f89b5f9",
				id: "googlebiz:6sf5aseX"
			},
			{
				title: "🗨️ Reply to Facebook messenger requests with standard copy/paste",
				videoUrl: "https://www.loom.com/share/e1fe153cce6a402895db10b04cf1e237?sid=617fc73f-20d7-4e18-a6b6-04fa870de925",
				id: "googlebiz:VqxtALvM"
			},
			{
				title: "📞Call back new leads using the bribe call script",
				info: "https://docs.google.com/document/d/1NusY3xpq6riQcp_O4qo07oDw6lQ43HDm086UcRVTZm4/edit?usp=sharing",
				id: "googlebiz:t_7asikK"
			},
			{
				title: "📞Retry calling earlier leads (5 strikes rule)",
				id: "googlebiz:gO-nFUVG"
			},
			{
				title: "📞Call back new bribe calls with next step script",
				info: "https://docs.google.com/document/d/1w4NHSyVq7kRgvB9rGYnCZ0V8U5pgJOr6hsfXsHTW9yQ/edit?usp=sharing",
				id: "googlebiz:0xx1CLcT"
			}
		],
		id: "BhbVD8vD"
	},
	{
		title: "The Yard Dog Playbook",
		items: [
			{
				title: "🔃 Review the Yard dog playbook",
				info: "pb:yardDogPlaybook",
				videoUrl: "https://www.loom.com/share/126a219282484e06b22a6ec9ee2f4199?sid=869ca423-a2cb-47eb-b178-f37057c5859f",
				id: "googlebiz:FrVCSN16"
			},
			{
				title: "⚠️ Design new lead-generating sign riders/signs",
				videoUrl: "https://www.loom.com/share/23c5692042144031803cb4b689b44755?sid=029a39aa-745c-4103-87a0-a37badc5df30",
				id: "googlebiz:yardDogPlaybook"
			},
			{
				title: "♻️☮️ Renew Craigslist ads",
				videoUrl: "https://www.loom.com/share/ab32d161a47142e58ab19f52aa1e6e36?sid=956c9d53-5b52-4029-8b3d-f3fa8f89b5f9",
				id: "googlebiz:6sf5aseX"
			},
			{
				title: "🗨️ Reply to Facebook messenger requests with standard copy/paste",
				videoUrl: "https://www.loom.com/share/e1fe153cce6a402895db10b04cf1e237?sid=617fc73f-20d7-4e18-a6b6-04fa870de925",
				id: "googlebiz:VqxtALvM"
			},
			{
				title: "📞Call back new leads using the bribe call script",
				info: "https://docs.google.com/document/d/1NusY3xpq6riQcp_O4qo07oDw6lQ43HDm086UcRVTZm4/edit?usp=sharing",
				id: "googlebiz:t_7asikK"
			},
			{
				title: "📞Retry calling earlier leads (5 strikes rule)",
				id: "googlebiz:gO-nFUVG"
			},
			{
				title: "📞Call back new bribe calls with next step script",
				info: "https://docs.google.com/document/d/1w4NHSyVq7kRgvB9rGYnCZ0V8U5pgJOr6hsfXsHTW9yQ/edit?usp=sharing",
				id: "googlebiz:0xx1CLcT"
			}
		],
		id: "_BhIIdHU"
	},
	{
		title: "Review Day",
		items: [
			{
				title: "📅 Schedule a Progress Review with your coach",
				info: "https://calendly.com/customer-success-55/progress-review",
				id: "googlebiz:Rk4tFOBr"
			},
			{
				title: "📝 Send us a report with your #s",
				id: "googlebiz:nHXHADo-"
			},
			{
				title: "🎁 Receive a gift when you send in metrics for leads/bribe calls/pre-qualifications/CMAs",
				id: "googlebiz:GBKfmkZg"
			},
			{
				title: "📷 Photo/Video appt. #1 from Zillow-Jacking playbook",
				videoUrl: "https://www.loom.com/share/5567b85621344542a14bd66e61f581cc?sid=b55d2bd5-c259-4c14-b204-def0c6125e32",
				id: "googlebiz:PkKqNMsV"
			},
			{
				title: "📞Call #2 after FSBO appt with the Fizbonanza script",
				info: "https://docs.google.com/document/d/12hwfJFR2PYATGoOkPR-cVRo6gWWmu_WQznl_4ysR1RU/edit?usp=sharing",
				id: "googlebiz:KPYtJV1g"
			},
			{
				title: "📷 Photo/Video appt. #2 from Zillow-Jacking playbook",
				videoUrl: "https://www.loom.com/share/5567b85621344542a14bd66e61f581cc?sid=b55d2bd5-c259-4c14-b204-def0c6125e32",
				id: "googlebiz:gJJ0uCCB"
			},
			{
				title: "📞Call #2 after FSBO appt with the Fizbonanza script",
				info: "https://docs.google.com/document/d/12hwfJFR2PYATGoOkPR-cVRo6gWWmu_WQznl_4ysR1RU/edit?usp=sharing",
				id: "googlebiz:42qe9aJ-"
			},
			{
				title: "♻️☮️ Renew Craigslist ads",
				videoUrl: "https://www.loom.com/share/ab32d161a47142e58ab19f52aa1e6e36?sid=956c9d53-5b52-4029-8b3d-f3fa8f89b5f9",
				id: "googlebiz:6sf5aseX"
			},
			{
				title: "🗨️ Reply to Facebook messenger requests with standard copy/paste",
				videoUrl: "https://www.loom.com/share/e1fe153cce6a402895db10b04cf1e237?sid=617fc73f-20d7-4e18-a6b6-04fa870de925",
				id: "googlebiz:VqxtALvM"
			},
			{
				title: "📞Call back new leads using the bribe call script",
				info: "https://docs.google.com/document/d/1NusY3xpq6riQcp_O4qo07oDw6lQ43HDm086UcRVTZm4/edit?usp=sharing",
				id: "googlebiz:t_7asikK"
			},
			{
				title: "📞Retry calling earlier leads (5 strikes rule)",
				id: "googlebiz:gO-nFUVG"
			},
			{
				title: "📞Call back new bribe calls with next step script",
				info: "https://docs.google.com/document/d/1w4NHSyVq7kRgvB9rGYnCZ0V8U5pgJOr6hsfXsHTW9yQ/edit?usp=sharing",
				id: "googlebiz:0xx1CLcT"
			}
		],
		id: "q7C4MjKh"
	},
	{
		title: "Build A Rythm",
		items: [
			{
				title: "📅 Add next X-forecast broadcast to your calendar",
				videoUrl: "https://www.loom.com/share/ce18c6ebcb7b4c0cb2479082e4a6eb86?sid=0278e046-3229-434b-93c2-c3b0a0eb3c9f",
				id: "googlebiz:etpBulII"
			},
			{
				title: "📅 Add next Upcirculating execution to your calendar",
				videoUrl: "https://www.loom.com/share/c296a2d6c13f47118dbcb021b82a3755?sid=85604227-1aa3-4d3a-b117-9c5d88c2ab6f",
				id: "googlebiz:Vq641C1y"
			},
			{
				title: "🕒 Review quick note on time-blocking",
				videoUrl: "https://www.loom.com/share/25f4199f75e3459197fcbf829625f7a3?sid=080f181f-244b-471c-89b0-81dd7815fee8",
				id: "googlebiz:hjPbluUe"
			},
			{
				title: "🔎 Create plan for weekly execution of the Zillow-jacking playbook",
				id: "googlebiz:updateEvergreenPlan"
			},
			{
				title: "📷 Photo/Video appt. #2 from Zillow-Jacking playbook",
				videoUrl: "https://www.loom.com/share/5567b85621344542a14bd66e61f581cc?sid=b55d2bd5-c259-4c14-b204-def0c6125e32",
				id: "googlebiz:gJJ0uCCB"
			},
			{
				title: "📞Call #2 after FSBO appt with the Fizbonanza script",
				info: "https://docs.google.com/document/d/12hwfJFR2PYATGoOkPR-cVRo6gWWmu_WQznl_4ysR1RU/edit?usp=sharing",
				id: "googlebiz:iIRBmIOR"
			},
			{
				title: "♻️☮️ Renew Craigslist ads",
				videoUrl: "https://www.loom.com/share/ab32d161a47142e58ab19f52aa1e6e36?sid=956c9d53-5b52-4029-8b3d-f3fa8f89b5f9",
				id: "googlebiz:6sf5aseX"
			},
			{
				title: "🗨️ Reply to Facebook messenger requests with standard copy/paste",
				videoUrl: "https://www.loom.com/share/e1fe153cce6a402895db10b04cf1e237?sid=617fc73f-20d7-4e18-a6b6-04fa870de925",
				id: "googlebiz:VqxtALvM"
			},
			{
				title: "📞Call back new leads using the bribe call script",
				info: "https://docs.google.com/document/d/1NusY3xpq6riQcp_O4qo07oDw6lQ43HDm086UcRVTZm4/edit?usp=sharing",
				id: "googlebiz:t_7asikK"
			},
			{
				title: "📞Retry calling earlier leads (5 strikes rule)",
				id: "googlebiz:gO-nFUVG"
			},
			{
				title: "📞Call back new bribe calls with next step script",
				info: "https://docs.google.com/document/d/1w4NHSyVq7kRgvB9rGYnCZ0V8U5pgJOr6hsfXsHTW9yQ/edit?usp=sharing",
				id: "googlebiz:0xx1CLcT"
			}
		],
		id: "09sFNL0o"
	}
]